import { Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { Check, Close, Delete } from '@mui/icons-material';

interface ConnectionContextMenuProps {
  anchorPosition: { top: number; left: number } | null;
  isOptional: boolean;
  canMakeOptional: boolean; // Validation flag
  onClose: () => void;
  onToggleOptional: () => void;
  onDelete: () => void;
}

const ConnectionContextMenu = ({
  anchorPosition,
  isOptional,
  canMakeOptional,
  onClose,
  onToggleOptional,
  onDelete,
}: ConnectionContextMenuProps) => {
  // Determine if "Make Optional" should be disabled
  const isMakeOptionalDisabled = !isOptional && !canMakeOptional;

  return (
    <Menu
      open={anchorPosition !== null}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition || undefined}
    >
      <Tooltip
        title={
          isMakeOptionalDisabled
            ? 'Multiple connections required to make this optional'
            : ''
        }
        placement="left"
      >
        <span>
          <MenuItem
            onClick={onToggleOptional}
            disabled={isMakeOptionalDisabled}
          >
            <ListItemIcon>
              {isOptional ? (
                <Check fontSize="small" />
              ) : (
                <Close fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText>
              {isOptional ? 'Make Required' : 'Make Optional'}
            </ListItemText>
          </MenuItem>
        </span>
      </Tooltip>
      <MenuItem onClick={onDelete} sx={{ color: 'error.main' }}>
        <ListItemIcon>
          <Delete fontSize="small" sx={{ color: 'error.main' }} />
        </ListItemIcon>
        <ListItemText sx={{ color: 'error.main' }}>Delete Connection</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default ConnectionContextMenu;

